import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useBuilderWhatsappIntegration } from '../../hooks/useBuilderWhatsappIntegration';

/**
 * Restricts WhatsApp campaign routes to builders with WhatsApp configured in Integrations.
 */
const RequireBuilderWhatsappForCampaigns = ({ children }) => {
  const location = useLocation();
  const { isPending, configured } = useBuilderWhatsappIntegration();

  if (isPending) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <Loader2 className="h-10 w-10 animate-spin text-customBlue" aria-label="Loading" />
      </div>
    );
  }

  if (!configured) {
    return <Navigate to="/builder/integration" replace state={{ blockedPath: location.pathname }} />;
  }

  return children;
};

export default RequireBuilderWhatsappForCampaigns;
